import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { I18nService } from './i18n';

/** Adds the bearer token and language; on 401 refreshes once and retries. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const i18n = inject(I18nService);
  const router = inject(Router);

  const withAuth = (r: HttpRequest<unknown>) => {
    const headers: Record<string, string> = { 'Accept-Language': i18n.lang() };
    if (auth.token) headers['Authorization'] = `Bearer ${auth.token}`;
    return r.clone({ setHeaders: headers });
  };

  return next(withAuth(req)).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 401 || req.url.includes('/api/v1/auth/')) {
        return throwError(() => err);
      }
      return from(auth.refresh()).pipe(
        switchMap((ok) => {
          if (!ok) {
            void router.navigate(['/login']);
            return throwError(() => err);
          }
          return next(withAuth(req));
        }),
      );
    }),
  );
};
